<template>
    <!-- ======= Footer ======= -->
  <footer id="footer">
    <div class="footer-top">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <div class="footer-info">
              <h4>گروه صنعتی سبلان تراک میکسر</h4>
              <p>
                تهران کیلومتر 40 جاده خاوران<br /><br />
                <strong>واتساپ:</strong> 09124965748<br />
                <strong>ایمیل:</strong> info@SabalanMixer.ir<br />
              </p>
              <div class="social-links mt-3">
                <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
                <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
                <a href="#" class="instagram"
                  ><i class="bx bxl-instagram"></i
                ></a>
                <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
                <a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a>
              </div>
            </div>
          </div>

          <div class="col-lg-2 col-md-6 footer-links">
            <h4>لینک های مفید</h4>
            <ul>
              <li><i class="bx bx-chevron-left"></i> <a href="#">صفحه اصلی</a></li>
              <li>
                <i class="bx bx-chevron-left"></i> <a href="#">درباره ما</a>
              </li>
              <li>
                <i class="bx bx-chevron-left"></i> <a href="#">خدمات</a>
              </li>
              <li>
                <i class="bx bx-chevron-left"></i>
                <a href="#">خدمات پس از فروش</a>
              </li>
              <li>
                <i class="bx bx-chevron-left"></i>
                <a href="#">مشاوره تجهیزات</a>
              </li>
            </ul>
          </div>

          <div class="col-lg-3 col-md-6 footer-links">
            <h4>خدمات</h4>
            <ul>
              <li>
                <i class="bx bx-chevron-left"></i> <a href="#">ساخت میکسر</a>
              </li>
              <li>
                <i class="bx bx-chevron-left"></i>
                <a href="#">تعمیرات انواع میکسر و قطعات</a>
              </li>
              <li>
                <i class="bx bx-chevron-left"></i>
                <a href="#">تامین قطعات</a>
              </li>
              <li>
                <i class="bx bx-chevron-left"></i> <a href="#">مشاوره رایگان</a>
              </li>
              <li>
                <i class="bx bx-chevron-left"></i>
                <a href="#">پمپ بتن</a>
              </li>
            </ul>
          </div>

          <div class="col-lg-4 col-md-6 footer-newsletter">
            <h4>خبرنامه</h4>
            <p>
              برای عضویت در خبرنامه و دریافت جدیدترین مقالات میکسر بتن آدرس
              ایمیلتان را وارد نمایید
            </p>
            <form action="" method="post">
              <input type="submit" value="عضویت در خبرنامه" /><input
                type="email"
                name="email"
              />
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="copyleft">تمامی حقوق این وب سایت محفوظ می باشد</div>
    </div>
  </footer>
  <!-- End Footer -->
</template>

<script>
export default {

}
</script>

<style>

</style>